module.exports = __webpack_public_path__ + "media/images/emblems/Val-ddIlliez-e918bf894eb4a530cf43e9ae76e52d0e.png";